<template>
    <div class="search-container" :class="{'search-center':!isHiddenSearchBox}">
        <div class="search-title" >
            <span class="line"></span>
            <slot name="title"></slot>
        </div>
        <div v-if="isHiddenSearchBox" class="search-wap-all">
            <slot></slot>
        </div>
        <!-- <div :class="[isHiddenSearchBox?'btn-search-open el-icon-arrow-up':'btn-search-close el-icon-arrow-down']" @click="openBox" v-if="isShowOpenButton"></div> -->
    </div>
</template>

<script>
export default {
    props: {
        isShowOpenButton: {
            type: Boolean,
            value: true
        }
    },
    data() {
        return {
          isHiddenSearchBox: true
        };
    },
    mounted() {
        if(!this.isShowOpenButton) this.isHiddenSearchBox=true;
    },
    methods: {
        openBox() {
            
            this.isHiddenSearchBox = !this.isHiddenSearchBox;
        
            //this.$emit("searchBoxChange", this.isHiddenSearchBox);
        }
    }
};
</script>


<style lang="less" scoped>
.hidden {
    display: none !important;
}
.search-container {
    background-color: #fff;
    padding: 10px 20px;
    padding-top: 0;
    border-radius: 8px;
    position: relative;
    transition: all 0.3s;
    overflow: hidden;
    display: flex;
    align-items: flex-start;
    position: relative;
    justify-content:space-between;
    // margin-top: 10px;
    flex-direction: column;
    .search-wap-all{
        width: 100%;
    }
    .search-title {
        font-size: 18px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        color: #333;
        height: 70px;
        border-bottom: 1px solid #e2e2e2;
        width: 100%;
        .line{
            width: 4px;
            height: 16px;
            background: #3572e2;
            margin-right: 12px;
        }
    }
    .btn-search-open,
    .btn-search-close {
        // position: absolute;
        // right: 30px;
        // top: 30px;
        color: #02acee;
        font-size: 15px;
        cursor: pointer;
    }
    > .panel-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 36px;
        line-height: 36px;
        margin-bottom: 15px;
        .panel-row-item-title {
            color: #666;
            min-width: 70px;
            text-align: right;
        }
        input[type="text"] {
            height: 36px;
            width: 170px;
            border: 1px solid #d7dde4;
            border-radius: 6px;
            margin-right: 30px;
            outline: none;
            padding-left: 10px;
            &::placeholder {
                color: #c3cbd6;
                font-size: 14px;
            }
        }
        .meb-cascader,
        .meb-input,
        .meb-select {
            margin-right: 20px;
        }
    }
    .btn-search {
        position: absolute;
        right: 200px;
        bottom: 20px;
        width: 74px;
        height: 36px;
        border-radius: 6px;
        background-color: #02acee;
        color: #fff;
        font-size: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 0;
        outline: none;
        cursor: pointer;
    }
    .btn-clear {
        width: 74px;
        height: 36px;
        position: absolute;
        right: 100px;
        bottom: 20px;
        border-radius: 6px;
        background-color: #fff;
        color: #666;
        border: 1px solid #f2f3f5;
        font-size: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        outline: none;
        cursor: pointer;
    }
}
.search-center{
    align-items: center;
}
</style>
<style>
.el-range-separator {
    width: 20px !important;
}
.el-tabs .search-container{margin-top:0;}
</style>
